import React, {FC, useEffect, useState} from "react";
import FilterTextFormField from "../FilterTextFormField";
import {Popover, Transition} from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/24/solid";
import {Fragment} from "react";
import FlightDateRangeInput from "./FlightDateRangeInput";
import {useGetCitiesQuery} from "store/api";
import ButtonCircle from "shared/Button/ButtonCircle";
import {EventType} from "data/types";

export interface FilterFormProps {
  fetchEvents: (params?: Record<string, any>) => void;
  onFilter: (events: EventType[]) => void;
}

export type TypeDropOffLocationType = "roundTrip" | "oneWay" | "";

const FilterForm: FC<FilterFormProps> = ({fetchEvents, onFilter}) => {
  const {data: dataCities} = useGetCitiesQuery({});
  const categories = [
    "Todos",
    "Concierto",
    "Formación Profesional",
    "Entretenimiento",
    "Cultura",
    "Deporte",
    "Turismo",
    "Sorteo",
    "Otros",
  ];
  const dateOptions = [
    "Todos",
    "Hoy",
    "Esta semana",
    "Próximo mes",
    "Este año",
    // "Personalizado",
  ];

  const cities = dataCities?.cantons || [];
  const [cityState, setCityState] = useState("Ciudad");
  const [cityIdState, setCityIdState] = useState("");
  const [categoryState, setCategoryState] = useState("Todos");
  const [filterDateState, setFilterDateState] = useState("Fecha");
  const [queryState, setQueryState] = useState("");

  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (filterDateState === "Personalizado") {
      setIsVisible(true);
      setIsAnimating(true);
    } else if (isVisible) {
      setIsAnimating(false);
      setTimeout(() => setIsVisible(false), 500);
    }
  }, [filterDateState, isVisible]);

  useEffect(() => {
    if (isInitialized) {
      searchEvents();
    }
  }, [cityIdState, categoryState, filterDateState]);

  const searchEvents = async () => {
    let params = {};
    if (cityIdState !== "") params = {...params, city: cityIdState};
    if (categoryState !== "Todos")
      params = {...params, category: categoryState};
    if (filterDateState !== "Fecha") {
      const indexDate = dateOptions.indexOf(filterDateState);
      params = {...params, type: indexDate};
    }
    if (queryState !== "") params = {...params, word: queryState};
    console.log("params", params);

    const result: any = await fetchEvents(params);
    if (result?.data?.eventDB) onFilter(result.data.eventDB);
  };

  const renderSelectCity = () => {
    return (
      <Popover className="relative">
        {({open, close}) => (
          <>
            <Popover.Button
              className={`
           ${open ? "" : ""}
            px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 text-xs`}
              onClickCapture={() => document.querySelector("html")?.click()}
            >
              <span>{`${cityState}`}</span>
              <ChevronDownIcon
                className={`${
                  open ? "" : "text-opacity-70"
                } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-20 w-screen max-w-[200px] sm:max-w-[220px] px-4 top-full mt-3 transform -translate-x-1/2 left-1/2 sm:px-0  ">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 ">
                  <div className="relative grid gap-8 bg-white dark:bg-neutral-800 p-7 ">
                    <a
                      href={"todos"}
                      onClick={(e) => {
                        e.preventDefault();
                        setCityState("Ciudad");
                        setCityIdState("");

                        close();
                      }}
                      className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                    >
                      <p className="text-sm font-medium ">Todos</p>
                    </a>
                    {cities.map((item: any) => (
                      <a
                        key={item.city.description}
                        href={item._id}
                        onClick={(e) => {
                          e.preventDefault();
                          setCityState(item.city.description);
                          setCityIdState(item._id);
                          close();
                        }}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <p className="text-sm font-medium ">
                          {item.city.description}
                        </p>
                      </a>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };
  const renderSelectCategory = () => {
    return (
      <Popover className="relative">
        {({open, close}) => (
          <>
            <Popover.Button
              className={`
           ${open ? "" : ""}
            px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 text-xs`}
              onClickCapture={() => document.querySelector("html")?.click()}
            >
              <span>{`${categoryState}`}</span>
              <ChevronDownIcon
                className={`${
                  open ? "" : "text-opacity-70"
                } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-20 w-screen max-w-[200px] sm:max-w-[220px] px-4 top-full mt-3 transform -translate-x-1/2 left-1/2 sm:px-0  ">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 ">
                  <div className="relative grid gap-8 bg-white dark:bg-neutral-800 p-7 ">
                    {categories.map((item: any) => (
                      <a
                        key={item}
                        href={item}
                        onClick={(e) => {
                          e.preventDefault();
                          setCategoryState(item);
                          close();
                        }}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <p className="text-sm font-medium ">{item}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };
  const renderSelectDate = () => {
    return (
      <Popover className="relative">
        {({open, close}) => (
          <>
            <Popover.Button
              className={`
           ${open ? "" : ""}
            px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 text-xs`}
              onClickCapture={() => document.querySelector("html")?.click()}
            >
              <span>{`${filterDateState}`}</span>
              <ChevronDownIcon
                className={`${
                  open ? "" : "text-opacity-70"
                } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-20 w-screen max-w-[200px] sm:max-w-[220px] px-4 top-full mt-3 transform -translate-x-1/2 left-1/2 sm:px-0  ">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 ">
                  <div className="relative grid gap-8 bg-white dark:bg-neutral-800 p-7 ">
                    {dateOptions.map((item: any) => (
                      <a
                        key={item}
                        href={item}
                        onClick={(e) => {
                          e.preventDefault();
                          setFilterDateState(item);
                          close();
                        }}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <p className="text-sm font-medium ">{item}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderRadioBtn = () => {
    return (
      <div className=" py-5 [ nc-hero-field-padding ] flex flex-row flex-wrap border-b border-neutral-100 dark:border-neutral-700">
        <div className="mr-2 my-1 sm:mr-3 border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderSelectCity()}
        </div>
        <div className="mr-2 my-1 sm:mr-3 border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderSelectCategory()}
        </div>
        <div className="mr-2 my-1 sm:mr-3 border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderSelectDate()}
        </div>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <div className="w-full relative mt-8 rounded-[40px] xl:rounded-[49px] rounded-t-2xl xl:rounded-t-3xl shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800">
        {renderRadioBtn()}
        <div className="flex flex-1 rounded-full">
          <FilterTextFormField
            placeHolder="Buscar"
            desc="Ingresa el nombre del evento"
            className="flex-1"
            onChange={(value) => setQueryState(value)}
          />
          {isVisible && (
            <>
              <div
                className={`self-center border-r border-slate-200 dark:border-slate-700 h-8 ${
                  isAnimating ? "animate-fadeIn" : "animate-fadeOut"
                }`}
              ></div>
              <div
                className={`self-center border-r border-slate-200 dark:border-slate-700 h-8 ${
                  isAnimating ? "animate-fadeIn" : "animate-fadeOut"
                }`}
              ></div>

              <FlightDateRangeInput
                className={`flex-1 ${
                  isAnimating ? "animate-fadeIn" : "animate-fadeOut"
                }`}
                hasButtonSubmit={false}
              />
            </>
          )}
          <div className="pr-2 xl:pr-4 z-10 flex items-center">
            <ButtonCircle
              onClick={searchEvents}
              className="h-14 md:h-16 w-full md:w-16 rounded-full bg-primary-6000 hover:bg-primary-700 flex items-center justify-center text-neutral-50 focus:outline-none"
            >
              <i className="las la-search text-3xl"></i>
            </ButtonCircle>
          </div>
        </div>
      </div>
    );
  };

  return renderForm();
};

export default FilterForm;
